import { toast } from "react-toastify";
import { createSlice,PayloadAction } from '@reduxjs/toolkit';
import CommonService from '../../services/CommonService';
import InsuranceService from '../../services/InsuranceService';
import { APIResponse } from '../types/Common';
import { STATUS_SUCCESS } from "@src/config/constant";


const common = createSlice({
    name: 'common',
    initialState: {
        common: {},
        rates: {},
        documentList: [],
        city: [],
        allCity: [],
        state: [],
        locality: [],
        stateWithCity: [],
        mmvList: {},
        getDealerList: [],
        sfaUserList: [],
        agencyBankList: [],
        district: [],
        newMMVlist:{}
    },
    reducers: {
        config: (state, action) => {
            state.common = action.payload;
        },
        city: (state, action) => {
            state.city = action.payload;
        },
        allCity: (state, action) => {
            state.allCity = action.payload;
        },
        state: (state, action) => {
            state.state = action.payload;
        },
        locality: (state, action) => {
            state.locality = action.payload;
        },

        rates: (state, action) => {
            state.rates = action.payload
        },
        documentList: (state, action) => {
            state.documentList = action.payload
        },
        stateWithCity: (state, action) => {
            state.stateWithCity = action.payload;
        },
        mmvList: (state, action) => {
            state.mmvList = { ...state.mmvList, ...action.payload };
        },
        getDealerList: (state, action) => {
            state.getDealerList = action.payload;
        },
        sfaUserList: (state, action) => {
            state.sfaUserList = action.payload;
        },
        agencyBankList: (state, action) => {
            state.agencyBankList = action.payload;
        },
        setDistrict: (state, action: any) => {
            state.district = action.payload;
        },
        setNewMMVlist: (state, action: PayloadAction<Record<string, any>>) => {
            state.newMMVlist = {...state.newMMVlist,...action.payload};
        }
    },
});

export default common.reducer;

export const { config, rates, city, allCity, state, locality, documentList, stateWithCity, mmvList, getDealerList, sfaUserList, agencyBankList, setDistrict,setNewMMVlist } = common.actions


export const getMasterConfig = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.getMasterConfig().then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(config(data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getMasterConfigAgencyId = (params: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.getMasterConfigAgencyId(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                resolve(response.data)
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getDashboardCount = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {

        CommonService.getDashboardCount().then(
            (response: APIResponse) => {

                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}

/**
 * Function to call updateMasterRate API
 * updates aon, vat, stamp duty, local_govt_taxes, base issue with min and max
 * @param params 
 * @returns 
 */
export const updateMasterRates = (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.updateMasterRates(params).then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}

/**
 * function to make API call for fetching all rates display on rule engine page
 * @param params 
 * @returns 
 */
export const fetchMasterRates = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.fetchMasterRates(params).then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    let data = response.data && response.data.data
                    resolve(data)
                    dispatch(rates(data))
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}

/**
 * function to update rates redux state
 * @param params 
 * @returns 
 */
export const updateReduxMasterRates = (params: object): any => {
    return async (dispatch: any) => {
        dispatch(rates(params))
    }
}
// import csv

export const importCsv = async (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.importCsv(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


// import uploadAddOnCsv

export const uploadAddOnCsv = async (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.uploadAddOnCsv(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const getDocumentListing = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getDocumentList(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                        let data = response.data && response.data.data
                        resolve(data)
                        dispatch(documentList(data))
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

// export const getStateCityList = () => async (dispatch: any) => {
//     return new Promise((resolve, reject) => {
//         CommonService.getStateCityList().then((response: APIResponse) => {
//             if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
//                 let data = response.data && response.data.data
//                 resolve(response.data)
//                 dispatch(city(data.city))
//                 dispatch(state(data.state))
//             }
//             else {
//                 let errorMsg = (response && response.data && response.data.message) || ''
//                 if (errorMsg) toast.error(response.data.message);
//                 resolve(response && response.data)
//             }
//         },
//             (error: Error) => {
//                 reject(error);
//             })
//     })
// }

// export const getlocalityList = (params: object) => async (dispatch: any) => {
//     return new Promise((resolve, reject) => {
//         CommonService.getlocalityList(params).then((response: APIResponse) => {
//             if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
//                 let data = response.data && response.data.data
//                 resolve(response.data)
//                 dispatch(locality(data))

//             } else {
//                 let errorMsg = (response && response.data && response.data.message) || ''
//                 if (errorMsg) toast.error(response.data.message);
//                 resolve(response && response.data)
//             }
//         },
//             (error: Error) => {
//                 reject(error);
//             })
//     })
// }



export const addDocument = (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.addDocument(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                resolve(response.data)

            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

// export const getStateWiseCityList = () => async (dispatch: any) => {
//     return new Promise((resolve, reject) => {
//         CommonService.getStateWiseCity().then((response: APIResponse) => {
//             if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
//                 let data = response.data && response.data.data
//                 resolve(response.data)
//                 dispatch(stateWithCity(data))

//             } else {
//                 let errorMsg = (response && response.data && response.data.message) || ''
//                 if (errorMsg) toast.error(response.data.message);
//                 resolve(response && response.data)
//             }
//         },
//             (error: Error) => {
//                 reject(error);
//             })
//     })
// }

export const getMMVList = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        let mmvPatams = JSON.parse(JSON.stringify(params));
        delete mmvPatams['category_id'];

        CommonService.getMMVList(mmvPatams).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(mmvList({ [params['category_id']]: data }))

            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

/**
 * API to fetch base issue rate with provided params
 * @param params 
 * @returns 
 */
export const fetchBaseRate = (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.fetchBaseIssueRate(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                resolve(response.data)

            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getDealesList = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getDealersList().then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(getDealerList(data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

/**
 * API to fetch SFA users by sfa role id
 * @param params
 * @returns
 */
export const getSfaUsersByRole = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getSfaUserByRole(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                resolve(response.data)
                dispatch(sfaUserList(response?.data?.data || []))

            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}



/**
 * function to update sfa user list state
 * @param params 
 * @returns 
 */
export const updateSfaUserList = (params: object): any => {
    return async (dispatch: any) => {
        dispatch(sfaUserList(params))
    }
}

// agency bank list
export const bankList = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.bankList()
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                        resolve(response.data)
                        dispatch(agencyBankList(response?.data?.data))
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const fetchTraRates = (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.fetchTraRates(params).then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}

// export const getDistrictList = (params: object) => async (dispatch: any) => {
//     return new Promise((resolve, reject) => {
//         CommonService.getDistrictList(params).then((response: APIResponse) => {
//             if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
//                 resolve(response.data)
//                 dispatch(setDistrict(response?.data?.data))
//             }
//             else {
//                 let errorMsg = (response && response.data && response.data.message) || ''
//                 if (errorMsg) toast.error(response.data.message);
//                 resolve(response && response.data)
//             }
//         },
//             (error: Error) => {
//                 reject(error);
//             })
//     })
// }

export const getDocUploadUrl = (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.getDocUploadUrl(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                resolve(response.data)
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getMMVListV1 = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getMMVListV1(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                //let data = response.data && response.data.data
                resolve(response.data)
                dispatch(mmvList(response?.data?.data))

            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getBrandList = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getBrandList(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(setNewMMVlist(data))
            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}
export const getParentModelList = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getParentModelList(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(setNewMMVlist(data))
            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}

export const getVersionList = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getVersionList(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(setNewMMVlist(data))
            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}

export const getStateList = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getStateList().then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(state(data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getCityList = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getCityList(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(city(data))

            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

// City of Birth is not tied to the residential state, so it needs the complete city
// list. getCityList() keeps only the cities of the selected states in `city`, hence a
// separate cache here. Fetched once per session.
export const getAllCityList = () => async (dispatch: any, getState: any) => {
    const cachedCityList = getState()?.common?.allCity
    if (cachedCityList?.length) return cachedCityList

    return new Promise((resolve, reject) => {
        CommonService.getCityList({ state: [] }).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                let data = response.data && response.data.data
                dispatch(allCity(data))
                resolve(data)
            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve([])
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getLocalityList = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getLocalityList(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(locality(data))

            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}
